import dayjs from 'dayjs';
import { ISession } from 'app/shared/model/session.model';
import { ActivityStatus } from 'app/shared/model/enumerations/activity-status.model';

export interface IActivity {
  id?: number;
  status?: keyof typeof ActivityStatus;
  type?: string;
  name?: string;
  description?: string | null;
  startDateTime?: dayjs.Dayjs;
  endDateTime?: dayjs.Dayjs;
  session?: ISession | null;
}

export const defaultValue: Readonly<IActivity> = {};
